/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'

import { NavLink, useNavigate } from 'react-router-dom'

import { authSignOut } from 'services'

import AppLogo from 'assets/img/splash-logo-blue.png'
import Button from 'components/commons/button'
import 'components/commons/header/header-style.css'

const AppHeader = () => {
  const navigate = useNavigate()

  const onLogout = async () => {
    try {
      await authSignOut()

      setTimeout(() => {
        localStorage.removeItem('token')
        navigate('/login')
      }, 1500)
    } catch (e: any) {
      console.log('failed to logout.', e.code)
    }
  }

  return (
    <div className='flex flex-col items-center bg-black px-10 py-6 md:py-0 md:flex-row lg:flex-row md:h-24 lg:h-24'>
      <NavLink to='/overview'>
        <div className='md:w-64'>
          <img src={AppLogo} width={85} alt='logo' />
        </div>
      </NavLink>
      <div className='flex-1 flex justify-around'>
        <div className='dropdown'>
          <button className='dropbtn'>Daily Changes</button>
          <div className='dropdown-content'>
            <NavLink
              to='/invalid-solana-nfts'
              className={({ isActive }) => (isActive ? 'underline underline-offset-2' : undefined)}
            >
              Invalid Solana NFTs
            </NavLink>
            <NavLink
              to='/discord-servers'
              className={({ isActive }) => (isActive ? 'underline underline-offset-2' : undefined)}
            >
              Discord Servers
            </NavLink>
            <NavLink
              to='/flagged-collections'
              className={({ isActive }) => (isActive ? 'underline underline-offset-2' : undefined)}
            >
              Flagged NFTs
            </NavLink>
            <NavLink
              to='/requested-collections'
              className={({ isActive }) => (isActive ? 'underline underline-offset-2' : undefined)}
            >
              Requested NFTs
            </NavLink>
            <NavLink
              to='/user-feedback'
              className={({ isActive }) => (isActive ? 'underline underline-offset-2' : undefined)}
            >
              User Feedback
            </NavLink>

            <NavLink
              to='/chat-reports'
              className={({ isActive }) => (isActive ? 'underline underline-offset-2' : undefined)}
            >
              Chat Reports
            </NavLink>

            <NavLink
              to='/news-articles'
              className={({ isActive }) => (isActive ? 'underline underline-offset-2' : undefined)}
            >
              News Articles
            </NavLink>
          </div>
        </div>

        <div className='dropdown'>
          <button className='dropbtn'>Health Monitoring</button>
          <div className='dropdown-content'>
            <NavLink
              to='/last-updated'
              className={({ isActive }) => (isActive ? 'underline underline-offset-2' : undefined)}
            >
              Last Updated
            </NavLink>
            <NavLink
              to='/last-updated-listings'
              className={({ isActive }) => (isActive ? 'underline underline-offset-2' : undefined)}
            >
              Last Updated Listings
            </NavLink>
            <NavLink
              to='/duplicate-nfts'
              className={({ isActive }) => (isActive ? 'underline underline-offset-2' : undefined)}
            >
              Duplicate NFTs
            </NavLink>
          </div>
        </div>

        <div className='dropdown'>
          <button className='dropbtn'>Settings</button>
          <div className='dropdown-content'>
            <NavLink
              to='/add-new-nft'
              className={({ isActive }) => (isActive ? 'underline underline-offset-2' : undefined)}
            >
              Add New NFT
            </NavLink>
            <NavLink
              to='/admin-settings'
              className={({ isActive }) => (isActive ? 'underline underline-offset-2' : undefined)}
            >
              Admin Settings
            </NavLink>
          </div>
        </div>

        <div className='dropdown'>
          <button className='dropbtn'>Archives</button>
          <div className='dropdown-content'>
            <NavLink
              to='/test-environment'
              className={({ isActive }) => (isActive ? 'underline underline-offset-2' : undefined)}
            >
              Test Environment
            </NavLink>
            <NavLink
              to='/trending-collections'
              className={({ isActive }) => (isActive ? 'underline underline-offset-2' : undefined)}
            >
              Missing Fields
            </NavLink>
            <NavLink
              to='/solana-volume-check'
              className={({ isActive }) => (isActive ? 'underline underline-offset-2' : undefined)}
            >
              SOL Volume
            </NavLink>
            <NavLink
              to='/live-news-feed'
              className={({ isActive }) => (isActive ? 'underline underline-offset-2' : undefined)}
            >
              Live News Feed
            </NavLink>
          </div>
        </div>

        <Button onClick={onLogout} style={{ color: '#13171E', backgroundColor: '#FFFFFF' }}>
          Logout
        </Button>
      </div>
    </div>
  )
}

export default AppHeader
